var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F4F7F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_17)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1927 8H26.9022L35.965 17.4599V35.8307C35.965 38.1314 34.1081 40 31.8073 40H16.1927C13.9037 40 12.0351 38.1314 12.0351 35.8307V12.1577C12.035 9.8686 13.9037 8 16.1927 8V8Z",
    fill: "#0DA86B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8905 8V17.3781H35.965L26.8905 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9854 31.2993H20.4321L19.3694 29.5124L18.3066 31.2993H16.7416L18.5869 28.1927L16.9636 25.4949H18.5285L19.3693 26.8963L20.1985 25.4949H21.7635L20.1518 28.2044L21.9854 31.2993ZM22.5343 31.2993V25.4949H24.0175V30.0379H26.5401V31.2993H22.5343V31.2993ZM28.9927 31.3694C28.4087 31.3694 27.8949 31.1825 27.4511 30.8205C27.019 30.4701 26.7737 30.0263 26.7387 29.5008L28.0117 29.1271C28.0467 29.4073 28.1635 29.6526 28.3621 29.8395C28.5723 30.0263 28.8059 30.1197 29.0628 30.1197C29.273 30.1197 29.4482 30.073 29.5883 29.9796C29.7168 29.8862 29.7869 29.7577 29.7869 29.6059C29.7869 29.4774 29.7285 29.3723 29.6233 29.2789C29.5182 29.1971 29.3781 29.1271 29.2146 29.0687C29.0511 29.0103 28.8526 28.9519 28.654 28.9052C28.4438 28.8468 28.2335 28.7767 28.035 28.6833C27.8248 28.6015 27.6379 28.4964 27.4744 28.3679C27.2992 28.2511 27.1708 28.076 27.0657 27.8541C26.9605 27.6438 26.9022 27.3869 26.9022 27.0949C26.9022 26.6161 27.1007 26.219 27.5094 25.9037C27.9182 25.5767 28.4087 25.4249 28.981 25.4249C29.5532 25.4249 30.0554 25.565 30.4758 25.8336C30.8963 26.1139 31.1649 26.476 31.27 26.9198L29.9386 27.4803C29.8802 27.2351 29.7634 27.0366 29.5999 26.8847C29.4364 26.7446 29.2262 26.6628 28.981 26.6628C28.7941 26.6628 28.6539 26.7095 28.5372 26.7797C28.4321 26.8497 28.3854 26.9548 28.3854 27.0833C28.3854 27.2001 28.4554 27.3052 28.5956 27.3869C28.7357 27.457 28.9226 27.5154 29.1328 27.5505C29.343 27.5855 29.5766 27.6439 29.8218 27.7256C30.0788 27.8191 30.3007 27.9125 30.5225 28.041C30.7328 28.1578 30.9079 28.3563 31.0481 28.6132C31.1999 28.8819 31.27 29.1972 31.27 29.5592C31.27 30.0964 31.0598 30.5403 30.6393 30.8672C30.2189 31.1942 29.6701 31.3694 28.9927 31.3694V31.3694Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.5b62fb4a.svg";
export { ForwardRef as ReactComponent };